import { render } from "./BlogLeftSidebarPage.vue?vue&type=template&id=164b312a"
import script from "./BlogLeftSidebarPage.vue?vue&type=script&lang=js"
export * from "./BlogLeftSidebarPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__